import React, { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useWindowSize } from "../../../../../Helpers";
import Button from "@components/Button";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import PagesHeader from "@components/PagesHeader";
import BrandLogo from "@components/BrandLogo";
import Switch from "@components/Switch";
import DOMPurify from "dompurify";

export default function TermsAndConditions({
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
  sendAnswers,
}) {
  const { ident } = useParams();
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const queryClient = useQueryClient();
  const gameQuestionsQuery = queryClient.getQueryData([
    "game-questions",
    ident,
  ]);
  const XGA = width >= 1020;
  const [isChecked, setIsChecked] = useState(false);
  const isUltraInsider =
    location.pathname.includes("/ultra-insider") ||
    location.pathname.includes("/ultrainsider");

  const handleNextButtonClick = (accepted, action) => {
    const currentQuestionIdent =
      gameQuestionsQuery.content[currentQuestion].ident;

    const answer_ident = accepted ? "true" : "false";

    setAnswers((prevAnswers) => {
      const alreadyAnswered = prevAnswers.find(
        (a) => a.question_ident === currentQuestionIdent,
      );

      if (!alreadyAnswered) {
        return [
          ...prevAnswers,
          {
            question_ident: currentQuestionIdent,
            answer_ident: answer_ident,
          },
        ];
      }

      return prevAnswers;
    });

    if (typeof action === "string" && action) {
      navigate(action);
      return;
    }

    setCurrentQuestion(currentQuestion + 1);
    setIsChecked(false);
  };

  const renderButtons = (wrapperClass) => {
    const buttons = gameQuestionsQuery?.content[currentQuestion]?.buttons;

    if (buttons?.length > 0) {
      return (
        <div className={wrapperClass}>
          {buttons.map((button, index) => {
            const requiresConsent =
              button.requiresConsent ?? (buttons.length === 1 || index > 0);

            return (
              <Button
                key={button.ident}
                btnClass={requiresConsent ? "yellow" : "yellow outline"}
                action={() =>
                  handleNextButtonClick(requiresConsent, button.action)
                }
                disabled={requiresConsent && !isChecked}
              >
                {button.answer}
              </Button>
            );
          })}
        </div>
      );
    }

    return (
      <div className={wrapperClass}>
        <Button
          btnClass="yellow outline"
          action={() => handleNextButtonClick(false)}
        >
          Ich verzichte auf die Teilnahme
        </Button>
        <Button
          action={() => handleNextButtonClick(true)}
          disabled={!isChecked}
        >
          Ich bin dabei – ab ins Gewinnspiel!
        </Button>
      </div>
    );
  };

  console.log(answers);

  return (
    <section
      className={`game-page quiz-mechanics ${ident} ${
        isUltraInsider ? "ultra-insider" : ""
      }`}
    >
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
            <LinearGradientProgressBar
              value={currentQuestion / gameQuestionsQuery.content.length}
            />
            <div className="game-question">
              <p
                className="question"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(gameQuestionsQuery?.content[currentQuestion].question),
                }}
              />
            </div>
            <div className={`switch-wrapper`}>
              <Switch
                checked={isChecked}
                onChange={() => setIsChecked((prev) => !prev)}
                label={
                  gameQuestionsQuery?.content[currentQuestion].answers[0].answer
                }
                name="terms"
                register={() => {}}
              />
            </div>
          </div>

          <div className="side-img">
            {XGA && (
              <>
                {" "}
                <BrandLogo brands={gameQuestionsQuery?.brands} />
                {gameQuestionsQuery.content[currentQuestion].desktopImgHid ? (
                  selected ===
                  gameQuestionsQuery.content[currentQuestion].correctAnswer ? (
                    <img
                      src={
                        gameQuestionsQuery.content[currentQuestion][
                          width < 1020 ? "mobileImg" : "desktopImg"
                        ]
                      }
                      alt=""
                    />
                  ) : (
                    <img
                      src={
                        gameQuestionsQuery.content[currentQuestion][
                          width < 1020 ? "mobileImgHid" : "desktopImgHid"
                        ]
                      }
                      alt=""
                    />
                  )
                ) : (
                  <div className="img-wrapper">
                    <img
                      src={
                        gameQuestionsQuery.content[currentQuestion][
                          width < 1020 ? "mobileImg" : "desktopImg"
                        ]
                      }
                      alt=""
                    />
                    {gameQuestionsQuery.content[currentQuestion]
                      ?.sideImageCopy && (
                      <p
                        dangerouslySetInnerHTML={{
                          __html:
                            DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion]
                              ?.sideImageCopy),
                        }}
                      />
                    )}
                  </div>
                )}
              </>
            )}
            {XGA && renderButtons("desktop-buttons-terms")}
          </div>
        </div>
      </div>

      {!XGA && renderButtons("mobile-buttons")}
    </section>
  );
}
